export default function trimInputSpaces(value) {
  if (typeof value === 'string') {
    let nextValue = value;

    if (value[0] === ' ') {
      nextValue = value.trim();
    } else if (value[value.length - 1] === ' ') {
      nextValue = `${value.trim()} `;
    }

    return nextValue.replace(/\s+/, ' ');
  }

  return value;
}
